import { MoonstarEditForm } from '../Moonstar/MoonstarEditForm';
import { MoonstarEdit } from '../Moonstar/MoonstarEdit';
import { ChecklistFormInputs } from './ChecklistFormInputs';

export function ChecklistsEditPage() {
  return (
    <MoonstarEdit redirect="list">
      <MoonstarEditForm>
        <ChecklistFormInputs />
      </MoonstarEditForm>
    </MoonstarEdit>
  );
}
